import { createSelector } from 'reselect';

const routerParamsConfig = {
  crmLeadId: {
    name: 'crmLeadId',
    getFormattedValue: value => value,
  },
  dgoCrmLeadId: {
    name: 'dgoCrmLeadId',
    getFormattedValue: value => (value ? value.slice(1) : ''),
  },
  orderNumber: {
    name: 'orderNumber',
    getFormattedValue: value => value,
  },
};

const getFormattedRouterParams = routerMatchParams =>
  Object.keys(routerParamsConfig).reduce((result, key) => {
    const paramConfig = routerParamsConfig[key];
    const formattedValue = paramConfig.getFormattedValue(
      routerMatchParams[key]
    );

    return {
      ...result,
      [paramConfig.name]: formattedValue,
    };
  }, {});

export const getRouterParams = (state, props) => props.params;

export const getFormattedRouterMatchParams = createSelector(
  getRouterParams,
  routerMatchParams => getFormattedRouterParams(routerMatchParams)
);
